import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import logo from "../assets/Group 1.webp";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = location.pathname === "/";
  const isActive = (path) => {
    return location.pathname.split('/')[1] === path ? "text-[#F37934]" : "hover:text-[#F37934]";

  }

  return (
    <nav className="w-full z-50 ">
      <div className="lg:hidden fixed inset-x-0 top-0 z-50 bg-[#F0F0E5] font-cinzel">
        <div className=" flex justify-between items-center px-2 py-3">
          <Link to="/" className="flex items-center flex-1 min-w-0 overflow-hidden" onClick={() => setIsOpen(false)}>
            <img src={logo} alt="Success Logo" className="h-8 w-auto flex-shrink-0" />
            <div className="flex flex-col ml-2 min-w-0">
              <h2 className="text-[#F37934] font-bold tracking-widest font-nimbus text-xl sm:text-2xl">
                SUCCESS
              </h2>
              <p className="font-poppins text-[#F37934] tracking-tight text-[6px] sm:text-[8px] truncate">
                Shipping Services (Chennai) Pvt Ltd
              </p>
            </div>
          </Link>
          <button
            aria-label="Toggle menu"
            className="text-[#F37934] text-3xl"
            onClick={() => setIsOpen((v) => !v)}
          >
            {isOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>

        {isOpen && (
          <div className="bg-[#F0F0E5] px-6 py-4 space-y-4 border-t border-[#E6E1D5]  text-sm sm:text-base">
            <Link to="/" className={`block ${isActive("")}`} onClick={() => setIsOpen(false)}>
              Home
            </Link>
            <Link to="/about" className={`block ${isActive("about")}`} onClick={() => setIsOpen(false)}>
              About Us
            </Link>
            <Link to="/services" className={`block ${isActive("services")}`} onClick={() => setIsOpen(false)}>
              Services
            </Link>
            <Link to="/gallery" className={`block ${isActive("gallery")}`} onClick={() => setIsOpen(false)}>
              Gallery
            </Link>
            <Link to="/blogs" className={`block ${isActive("blogs")}`} onClick={() => setIsOpen(false)}>
              Blogs
            </Link>
            <Link
              to="/contact"
              className="block border border-[#F37934] text-[#F37934] px-4 py-2 font-bold rounded hover:bg-[#F37934] hover:text-white transition"
              onClick={() => setIsOpen(false)}
            >
              Contact Us
            </Link>
          </div>
        )}
      </div>
      {/* Spacer for fixed mobile bar */}
      <div className="md:hidden h-20" />

      {/* Desktop: Home (vertical at top, fixed horizontal after scroll) */}
      {isHome && (
        <div className="hidden lg:block">
          {scrolled ? (
            <>
              <div className="fixed inset-x-0 top-0 z-50 bg-[#F0F0E5]">
                <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-4 h-24">
                  <Link to="/" className="flex items-center">
                    <img src={logo} alt="Success Logo" className="h-8 w-20" />
                    <div className="flex flex-col py-0">
                      <h2 className="text-[#F37934] font-bold tracking-widest font-nimbus text-2xl md:text-4xl lg:text-4xl">
                        SUCCESS
                      </h2>
                      <p className="font-poppins text-[#F37934] tracking-tight text-[7px] sm:text-[10px] md:text-[10px] lg:text-[10px]">
                        Shipping Services (Chennai) Pvt Ltd
                      </p>
                    </div>
                  </Link>

                  <ul className="flex flex-wrap gap-6 lg:gap-12 text-lg font-cinzel font-bold items-center">
                    <li>
                      <Link to="/" className={`hover:text-[#F37934] ${isActive("")}`}>Home</Link>
                    </li>
                    <li>
                      <Link to="/about" className={`hover:text-[#F37934] ${isActive("about")}`}>About Us</Link>
                    </li>
                    <li>
                      <Link to="/services" className={`hover:text-[#F37934] ${isActive("services")}`}>Services</Link>
                    </li>
                    <li>
                      <Link to="/gallery" className={`hover:text-[#F37934] ${isActive("gallery")}`}>Gallery</Link>
                    </li>
                    <li>
                      <Link to="/blogs" className={`hover:text-[#F37934] ${isActive("blogs")}`}>Blogs</Link>
                    </li>
                  </ul>

                  <Link
                    to="/contact"
                    className="px-4 py-2 border border-[#F37934] text-[#F37934] font-bold font-cinzel rounded hover:bg-[#F37934] hover:text-white transition"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
              <div className="hidden md:block h-20" />
            </>
          ) : (
            <div className="md:absolute md:top-8 md:z-50 font-cinzel text-right md:pr-8 lg:right-16 xl:right-28 2xl:right-40">
              <div className="flex flex-col py-10 items-end gap-6">
                <Link
                  to="/contact"
                  className="px-4 py-2 border border-[#F37934] text-[#F37934] font-bold rounded hover:bg-[#F37934] hover:text-white transition"
                >
                  Contact Us
                </Link>
                <ul className="flex flex-col items-end pt-6 gap-4 gap-y-10 text-lg font-bold">
                  <li>
                    <Link to="/" className={`hover:text-[#F37934] ${isActive("")}`}>Home</Link>
                  </li>
                  <li>
                    <Link to="/about" className={`hover:text-[#F37934] ${isActive("about")}`}>About Us</Link>
                  </li>
                  <li>
                    <Link to="/services" className={`hover:text-[#F37934] ${isActive("services")}`}>Services</Link>
                  </li>
                  <li>
                    <Link to="/gallery" className={`hover:text-[#F37934] ${isActive("gallery")}`}>Gallery</Link>
                  </li>
                  <li>
                    <Link to="/blogs" className={`hover:text-[#F37934] ${isActive("blogs")}`}>Blogs</Link>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Desktop: Other pages (always fixed) */}
      {!isHome && (
        <>
          <div className="hidden lg:block fixed inset-x-0 top-0 z-50 bg-[#F0F0E5]  font-cinzel">
            <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-4 h-24">
              <Link to="/" className="flex items-center">
                <img src={logo} alt="Success Logo" className="h-10 w-24" />
                <div className="flex flex-col py-6">
                  <h2 className="text-[#F37934] font-bold tracking-widest font-nimbus text-2xl md:text-4xl lg:text-4xl">
                    SUCCESS
                  </h2>
                  <p className="font-poppins text-[#F37934] tracking-tight text-[7px] sm:text-[10px] md:text-[10px] lg:text-[10px]">
                    Shipping Services (Chennai) Pvt Ltd
                  </p>
                </div>
              </Link>

              <ul className="flex flex-wrap gap-6 lg:gap-12 text-lg font-cinzel font-bold items-center">
                <li>
                  <Link to="/" className={`hover:text-[#F37934] ${isActive("")}`}>Home</Link>
                </li>
                <li>
                  <Link to="/about" className={`hover:text-[#F37934] ${isActive("about")}`}>About Us</Link>
                </li>
                <li>
                  <Link to="/services" className={`hover:text-[#F37934] ${isActive("services")}`}>Services</Link>
                </li>
                <li>
                  <Link to="/gallery" className={`hover:text-[#F37934] ${isActive("gallery")}`}>Gallery</Link>
                </li>
                <li>
                  <Link to="/blogs" className={`hover:text-[#F37934] ${isActive("blogs")}`}>Blogs</Link>
                </li>
              </ul>

              <Link
                to="/contact"
                className="px-4 py-2 border border-[#F37934] text-[#F37934] font-bold rounded hover:bg-[#F37934] hover:text-white transition"
              >
                Contact Us
              </Link>
            </div>
          </div>
          {/* Spacer for fixed desktop bar */}
          <div className="hidden md:block h-20" />
        </>
      )}
    </nav>
  );
};

export default Navbar;
